import { IGetPriceInfoDetailScales, IPriceInfoResponseData } from '../actions/get-price-info.action';
import { IPostCartItems } from '../actions/post-cart.action';

/**
 *
 * @param product
 * @returns formatted string
 */
export const formatPriceIndication = (product: IPostCartItems | IPriceInfoResponseData): string => {
    const { PriceAmount, PriceCurrency, PriceFactor, PriceUnit } = product;
    const formattedPriceIndication = PriceAmount
        ? `${PriceAmount} ${PriceCurrency} / ${Number(PriceFactor) === 1 ? '' : PriceFactor} ${PriceUnit}`
        : ``;

    return formattedPriceIndication;
};

/**
 *
 * @param scale
 * @param priceInformation
 * @returns formatted string
 */
export const formatScalePriceIndication = (scale: IGetPriceInfoDetailScales, priceInformation: IPriceInfoResponseData): string => {
    const { PriceUnit, PriceCurrency, PriceFactor } = priceInformation;
    const { PriceAmount } = scale;

    const formattedScalePriceIndication = `${PriceAmount} ${PriceCurrency} / ${Number(PriceFactor) === 1 ? '' : PriceFactor} ${PriceUnit}`;

    return formattedScalePriceIndication;
};
